import { render } from "./CreaListaMKTModal.vue?vue&type=template&id=64036b87"
import script from "./CreaListaMKTModal.vue?vue&type=script&lang=js"
export * from "./CreaListaMKTModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__